import styled from '@emotion/styled';
import { CircularProgress } from '@mui/material';

const StyledIndicator = styled(CircularProgress)(({ theme, color }) => ({
  color: color === 'error' ? undefined : theme.palette.text.secondary,
}));

type UploadOptionsLoadingIndicatorProps = {
  color: 'error' | undefined;
};

const UploadOptionsLoadingIndicator = ({
  color,
}: UploadOptionsLoadingIndicatorProps) => (
  <StyledIndicator size={18} color={color} />
);

export default UploadOptionsLoadingIndicator;
